/********************************************
* Product hero
********************************************/
function fnProductHero( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection					= $( oSection );

	/*****************
	* Colour toggle
	*****************/
	var oColourSwatches				= $( '.swatches', oSection );

	// Check if a product has more than 1 variant
	if ( oColourSwatches.length ) {
		$( 'i.colour', oColourSwatches ).each( fnUpdateProductColour );
	}

	function fnUpdateProductColour() {

		/**
		* On-click of colour swatch
		*/
		$( this ).click( function () {

			// Update 'selected' colour
			$( this ).addClass( 'selected' ).siblings( 'i.colour' ).removeClass( 'selected' );

			// Update SKU text
			var sColourSku				= $( this ).data( 'product-sku' ),
				oSkuText				= $( 'span.product-sku', oSection );

			$( oSkuText ).text( function( i, v ) {
				return sColourSku;
			});

			// Update featured images and lightbox gallery link
			var iVariantID				= $( this ).data( 'product-id' ),
				iVariantImageSrc		= $( this ).data( 'product-image' ),
				oFeaturedImage			= $( 'figure.featured-image', oSection ),
				oGalleryButton			= $( '.gallery-btn', oSection );

			oFeaturedImage.find( 'img' ).attr( 'src', iVariantImageSrc ).attr( 'data-src', iVariantImageSrc );
			oGalleryButton.find( 'a.permalink' ).attr( 'data-fancybox', iVariantID ).attr( 'href', iVariantImageSrc );

		});

	}

	/*****************
	* Redirect to new URL when size dropdown is selected
	*****************/
	$( '.product-grouping-dropdown select', oSection ).on( 'change', function() {
		var sLink           = $( this ).val();
		window.location     = sLink;
	});

}


// END OF DOCUMENT
